import React, { useState } from 'react';
import PackagePill from '@components/PackagePill';
import { IOrderPackages } from '@hooks/useCurrentOrder/models';
import { t } from '@i18n/index';
import { MdOpenInNew } from 'react-icons/md';
import { toast } from 'react-toastify';
import { CircularProgress } from '@material-ui/core';
import api from '@services/api';
import {
  InvoiceLink,
  InvoiceLinkWrapper,
  Link,
  SectionTitleSecondary,
  VtexLink,
} from './styles';

const vtexUrl = (currentPackage: IOrderPackages) => {
  const packageBrandProviderBaseSubdomain =
    currentPackage?.brand_provider?.payload.base_subdomain;
  const packageTypeCode = currentPackage?.package_type.code;

  if (packageTypeCode !== 'own_stock') {
    const vtex_url = `https://${packageBrandProviderBaseSubdomain}.myvtex.com/admin/orders/${currentPackage?.code}`;
    return (
      <VtexLink>
        <Link href={vtex_url} target="_blank">
          {' '}
          Ver pacote na VTEX
        </Link>
        <MdOpenInNew style={{ width: '1.25rem', height: '1.25rem' }} />
      </VtexLink>
    );
  }
  return '';
};

const PackageDetailsHeader: React.FC<{ currentPackage?: IOrderPackages }> = ({
  currentPackage,
}) => {
  const [downloadingInvoice, setDownloadingInvoice] = useState<number | null>(
    null,
  );

  const handleDownloadInvoice = async (key: string, index: number) => {
    if (downloadingInvoice === index) return;

    try {
      setDownloadingInvoice(index);
      toast.info('Aguarde o download da nota fiscal.', { autoClose: 6000 });

      const pdfUrl = `/admin/invoice-provider/${key}/pdf`;
      const response = await api.get(pdfUrl, { responseType: 'arraybuffer' });

      if (!response.data) {
        throw new Error('Erro ao obter a URL da nota fiscal');
      }

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');

      link.href = url;
      link.setAttribute('download', `NotaFiscal_${key}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      toast.success('Nota fiscal baixada com sucesso!', { autoClose: 5000 });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      toast.error('Nota fiscal com erro ou inexistente.', {
        autoClose: 5000,
      });
    } finally {
      setDownloadingInvoice(null);
    }
  };

  return (
    <div className="headerPosition">
      <div className="packageNameCodeStyle">
        <SectionTitleSecondary>
          {t('@order-detail-packages/PACKAGE_TITLE', 'Detalhes do Pacote: ')}
        </SectionTitleSecondary>
        <span style={{ marginLeft: '0.75rem' }}>
          <PackagePill order_package={currentPackage} />
        </span>
      </div>
      {currentPackage?.invoices && currentPackage.invoices.length > 0 && (
        <InvoiceLinkWrapper>
          {currentPackage.invoices.map((invoice, index) => (
            <InvoiceLink key={invoice.key}>
              <button
                type="button"
                onClick={() => handleDownloadInvoice(invoice.key, index)}
                disabled={downloadingInvoice === index}
              >
                {' '}
                <Link href="/#" onClick={e => e.preventDefault()}>
                  {downloadingInvoice === index ? (
                    <CircularProgress
                      size={20}
                      style={{
                        color: '#DCC6B7',
                      }}
                    />
                  ) : (
                    'Nota Fiscal'
                  )}
                  {currentPackage.invoices.length > 1 ? ` ${index + 1}` : ''}
                </Link>
              </button>
              <MdOpenInNew style={{ width: '1.25rem', height: '1.25rem' }} />
            </InvoiceLink>
          ))}
        </InvoiceLinkWrapper>
      )}
      {currentPackage && vtexUrl(currentPackage)}
    </div>
  );
};

export default PackageDetailsHeader;
